import * as Sentry from '@sentry/react';

export function initSentry(): void {
  const env = import.meta.env as Record<string, string | undefined>;
  const dsn = env['VITE_SENTRY_DSN'];
  if (!dsn) return;

  const release = env['VITE_RELEASE_SHA'];

  Sentry.init({
    dsn,
    environment: env['VITE_SENTRY_ENVIRONMENT'] ?? 'dev',
    ...(release ? { release } : {}),
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
